import {
	ChangeDetectionStrategy,
	Component,
	Input,
	forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TestHooks } from './requisition-text-areas.hooks';

export interface IRequisitionTextAreaModel {
	text: string;
	requisitionText: string;
}

@Component({
	selector: 'app-requisition-text-areas',
	templateUrl: './requisition-text-areas.component.html',
	styleUrls: ['./requisition-text-areas.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => RequisitionTextAreasComponent),
			multi: true,
		},
	],
	standalone: false,
})
export class RequisitionTextAreasComponent implements ControlValueAccessor {
	testHooks = TestHooks;
	@Input() initialValueText: IRequisitionTextAreaModel = {
		text: '',
		requisitionText: '',
	};
	public disabled = false;
	public value: IRequisitionTextAreaModel = { text: '', requisitionText: '' };

	onChange: (value: IRequisitionTextAreaModel) => void;
	onTouched: () => void;

	writeValue(obj: IRequisitionTextAreaModel) {
		if (obj) {
			this.value = { ...this.value, ...obj };
		}
	}

	registerOnChange(fn: VoidFunction) {
		this.onChange = fn;
	}

	registerOnTouched(fn: VoidFunction) {
		this.onTouched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	_onChange = (key: keyof IRequisitionTextAreaModel, value: string) => {
		this.value[key] = value;
		this.onChange(this.value);
	};
}
